if (!customElements.get('affiliate-signup')) {
  let turnstileLoading;
  const countryCodes = 'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
  customElements.define('affiliate-signup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal || this.events) return;
      this.events = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.form.querySelector('[type="submit"]');
      this.status = this.querySelector('[data-signup-status]');
      this.label = this.button.textContent;
      this.submissionId ||= [...crypto.getRandomValues(new Uint8Array(16))].map(byte=>byte.toString(16).padStart(2,'0')).join('');
      const country = this.form.elements.country;
      const names = new Intl.DisplayNames([document.documentElement.lang || 'en'], {type:'region'});
      country.replaceChildren(...countryCodes.map(code=>new Option(names.of(code),code)) .sort((a,b)=>a.text.localeCompare(b.text)));
      country.value = countryCodes.includes(this.dataset.country) ? this.dataset.country : 'GB';
      const options = { signal: this.events.signal };
      const section = this.closest('.shopify-section');
      section.querySelectorAll('[data-affiliate-signup]').forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', this.dialog.id);
      });
      section.addEventListener('click', event => {
        const link = event.target.closest('[data-affiliate-signup]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.show(link);
      }, options);
      this.querySelector('[data-signup-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.cancelChallenge?.();
        document.body.classList.remove('affiliate-signup-open');
        this.opener?.focus({ preventScroll: true });
      }, options);
      section.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) this.show();
      }, options);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(); }, options);
      for (const name of ['password','password_confirmation']) this.form.elements[name].addEventListener('input', () => this.form.elements.password_confirmation.setCustomValidity(''), options);
    }

    show(opener) {
      this.opener = opener;
      if (!this.dialog.open) this.dialog.showModal();
      document.body.classList.add('affiliate-signup-open');
      window.pauseAllMedia?.();
      this.ready();
    }

    message(text, error=false) {
      this.status.textContent = text;
      this.status.toggleAttribute('data-error', error);
    }

    async ready() {
      if (this.checked || this.dataset.enabled !== 'true' || !this.dataset.sitekey) return;
      let endpoint;
      try { endpoint = new URL(this.dataset.endpoint); } catch { return; }
      if (endpoint.protocol !== 'https:' || endpoint.pathname !== '/signup' || endpoint.username || endpoint.password || endpoint.search || endpoint.hash) return;
      this.checked = true;
      try {
        const health = new URL('/health',endpoint);
        const response = await fetch(health,{credentials:'omit',signal:AbortSignal.timeout(10000)});
        const result = await response.json();
        if (!response.ok || !result.configured) throw Error();
        this.endpoint = endpoint.href;
        this.querySelector('[data-signup-fallback]').hidden = true;
        this.button.disabled = false;
      } catch { this.message((window.sonicStrings?.signup_unavailable || "Signup is temporarily unavailable. Please use the existing signup page below."),true); }
    }

    async challenge() {
      if (!window.turnstile) {
        turnstileLoading ||= new Promise((resolve,reject) => {
          const script=document.createElement('script');
          const failed=()=>{clearTimeout(timeout);turnstileLoading=null;script.remove();reject(Error((window.sonicStrings?.security_load_failed || "Security verification could not load. Please try again.")));};
          const timeout=setTimeout(failed,15000);
          script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.onload=()=>{clearTimeout(timeout);resolve();};script.onerror=failed;
          document.head.append(script);
        });
        await turnstileLoading;
      }
      return new Promise((resolve,reject) => {
        let widget;
        const finish=(token)=>{clearTimeout(timeout);if(widget!==undefined)window.turnstile.remove(widget);this.cancelChallenge=null;token?resolve(token):reject(Error((window.sonicStrings?.security_required || "Please complete the security verification and try again.")));};
        const timeout=setTimeout(()=>finish(),120000);
        this.cancelChallenge=()=>finish();
        widget=window.turnstile.render(this.querySelector('[data-signup-challenge]'),{sitekey:this.dataset.sitekey,action:'affiliate_signup',appearance:'interaction-only',callback:finish,'error-callback':()=>finish(),'expired-callback':()=>finish()});
      });
    }

    async submit() {
      if (!this.endpoint || this.busy || this.finished) return;
      const confirm=this.form.elements.password_confirmation;
      confirm.setCustomValidity(confirm.value===this.form.elements.password.value?'':(window.sonicStrings?.password_mismatch || "Your passwords do not match."));
      if (!this.form.reportValidity()) return;
      this.busy=true;this.button.disabled=true;this.button.textContent=(window.sonicStrings?.submitting || "Submitting…");this.form.setAttribute('aria-busy','true');
      let posted=false;
      try {
        const data=Object.fromEntries(new FormData(this.form));
        data.consent=this.form.elements.consent.checked;data.submission_id=this.submissionId;
        this.message((window.sonicStrings?.security_wait || "Please complete the security verification…"));
        data.challenge=await this.challenge();
        this.message((window.sonicStrings?.signup_sending || "Submitting your application…"));
        posted=true;
        const response=await fetch(this.endpoint,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(data),signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if (!response.ok || result.ok!==true) {
          const error=Error(window.sonicServerErrors?.[result.error]||result.error||(window.sonicStrings?.signup_unconfirmed || "We could not confirm your application. Please contact support before trying again."));
          error.uncertain=!result.code||['uncertain','changed','unavailable'].includes(result.code);
          throw error;
        }
        this.finished=true;this.form.reset();
        this.message((window.sonicStrings?.signup_received || "Thank you. Your application has been received. Please check your email for the next steps."));
        this.form.querySelector('.affiliate-signup__fields').hidden=true;
        this.form.querySelector('.affiliate-signup__actions').hidden=true;
        this.dialog.classList.add('affiliate-signup--complete');
        this.querySelector('.affiliate-signup__heading h2').textContent=this.dataset.receivedHeading;
        const close=document.createElement('button');
        close.type='button';close.className='affiliate-button affiliate-signup__complete';
        close.textContent=this.querySelector('[data-signup-close]').getAttribute('aria-label');
        close.addEventListener('click',()=>this.dialog.close(),{signal:this.events.signal});
        this.status.after(close);
      } catch(error) {
        this.finished=error.uncertain??posted;
        this.message(this.finished?(window.sonicStrings?.signup_uncertain || "Your application may have been received. Please check your email or contact support before trying again."):error.message,true);
        if(this.finished) this.form.querySelectorAll('[type="password"]').forEach(input=>{input.value='';});
      } finally {
        this.busy=false;this.button.disabled=this.finished;this.button.textContent=this.label;this.form.removeAttribute('aria-busy');
        if(this.dialog.open) this.status.focus({preventScroll:false});
      }
    }

    disconnectedCallback() {
      this.dialog?.close();
      this.events?.abort();
      this.events = null;
      this.cancelChallenge?.();
      document.body.classList.remove('affiliate-signup-open');
    }
  });
}
